"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualError = void 0;
class ContextualError extends Error {
    code;
    /** Parent operation context. */
    context;
    error;
    publicMessage;
    constructor(options) {
        super(options.publicMessage);
        this.name = "ContextualError";
        this.code = options.code;
        this.error = options.error;
        this.stack = options.error.stack;
        this.publicMessage = options.publicMessage;
        if (!options.code) {
            throw new Error(`Failed to create a contextual "${this.name}" without an error code.`);
        }
    }
    /**
     * Extend this error with a parental context.
     * @param context Parental context.
     * @example
     * const error = new ContextualError({
     *   code: 'GIT_PULL_REJECTED',
     *   details,
     * })
     * error.setContext('GIT_COMMIT')
     */
    setContext(context) {
        this.context = context;
        return this;
    }
}
exports.ContextualError = ContextualError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGV4dHVhbEVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0NvbnRleHR1YWxFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFTQSxNQUFhLGVBQXVDLFNBQVEsS0FBSztJQUMvQyxJQUFJLENBQU87SUFDM0IsZ0NBQWdDO0lBQ3pCLE9BQU8sQ0FBVztJQUNULEtBQUssQ0FBUTtJQUNiLGFBQWEsQ0FBUztJQUV0QyxZQUFZLE9BQXFDO1FBQy9DLEtBQUssQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLENBQUM7UUFFN0IsSUFBSSxDQUFDLElBQUksR0FBRyxpQkFBaUIsQ0FBQztRQUM5QixJQUFJLENBQUMsSUFBSSxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUM7UUFDekIsSUFBSSxDQUFDLEtBQUssR0FBRyxPQUFPLENBQUMsS0FBSyxDQUFDO1FBQzNCLElBQUksQ0FBQyxLQUFLLEdBQUcsT0FBTyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUM7UUFDakMsSUFBSSxDQUFDLGFBQWEsR0FBRyxPQUFPLENBQUMsYUFBYSxDQUFDO1FBRTNDLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDbEIsTUFBTSxJQUFJLEtBQUssQ0FDYixrQ0FBa0MsSUFBSSxDQUFDLElBQUksMEJBQTBCLENBQ3RFLENBQUM7UUFDSixDQUFDO0lBQ0gsQ0FBQztJQUVEOzs7Ozs7Ozs7T0FTRztJQUNJLFVBQVUsQ0FBQyxPQUFnQjtRQUNoQyxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztRQUN2QixPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7Q0FDRjtBQXJDRCwwQ0FxQ0MifQ==